export const getPercentAverage = (
  gradedAssignments: { grade?: number; [key: string]: any }[]
) =>
  Math.round(
    gradedAssignments.reduce((acc, val) => {
      return acc + Math.round(Number(val.grade));
    }, 0) / gradedAssignments.length
  ) || 0;
